/**
 * Google Maps JavaScript API key.
 * Replace REACT_APP_GOOGLE_MAPS_API_KEY when a real key is ready.
 * The fallback is a placeholder so the loader stays wired.
 */
export const DEFAULT_GOOGLE_MAPS_API_KEY = 'AIzaSyA1b2C3d4E5f6G7h8I9j0K1l2M3n4O5p6Q';

export function getGoogleMapsApiKey(): string {
  const configured = process.env.REACT_APP_GOOGLE_MAPS_API_KEY?.trim();
  if (configured) return configured;
  return DEFAULT_GOOGLE_MAPS_API_KEY;
}
